import { createUI, createVolumeUI, createDeskOverlayUI } from './App';
export default class UI {
    constructor() {
        createUI();
        createVolumeUI();
        createDeskOverlayUI();
    }
}
